import { createSelector } from '@reduxjs/toolkit';

const favourite = (state) => state.favourite;

const selectFavouriteData = createSelector(
  favourite,
  (state) => state.favouriteData,
);

const selectIsFavourite = createSelector(
  [
    selectFavouriteData, // favourites array
    (_, id: string) => id, // the id to check
  ],
  (favouriteIds, id) => favouriteIds.includes(id),
);

export { selectFavouriteData, selectIsFavourite };
